import React from 'react';
import {
	fitnessProfileFormErrorClassName,
	fitnessProfileModalBackdropClassName,
	fitnessProfileModalPanelClassName
} from './shared/fitnessProfileReadingStyles';

export default function FitnessProfileReadingsManageModal({
	isOpen,
	onClose,
	title,
	emptyMessage,
	items,
	onEdit,
	onDelete,
	deletingId,
	error
}) {
	if (!isOpen) return null;

	return (
		<div
			className={`${fitnessProfileModalBackdropClassName} max-w-none`}
			onClick={onClose}
			role="presentation"
		>
			<div
				className={`${fitnessProfileModalPanelClassName} max-w-md flex flex-col`}
				style={{ maxHeight: '85vh' }}
				onClick={(event) => event.stopPropagation()}
				role="dialog"
				aria-modal="true"
				aria-labelledby="readings-manage-modal-title"
			>
				<div className="flex items-center justify-between gap-3 border-b border-gray-200 dark:border-dark-border pb-3 shrink-0">
					<h3 id="readings-manage-modal-title" className="text-lg font-semibold text-gray-900 dark:text-dark-text">
						{title}
					</h3>
					<button
						type="button"
						onClick={onClose}
						className="flex h-8 w-8 items-center justify-center rounded-full text-xl font-semibold leading-none text-gray-500 dark:text-dark-text-secondary hover:bg-gray-100 dark:hover:bg-dark-bg hover:text-gray-700 dark:hover:text-dark-text transition"
						aria-label="Close"
					>
						×
					</button>
				</div>

				<div className="mt-4 flex-1 overflow-y-auto min-h-0">
					{error && (
						<p className={`mb-3 ${fitnessProfileFormErrorClassName}`} role="alert">
							{error}
						</p>
					)}

					{items.length === 0 ? (
						<p className="text-sm text-gray-500 dark:text-dark-text-secondary">{emptyMessage}</p>
					) : (
						<ul className="space-y-2">
							{items.map((item) => (
								<li
									key={item.id}
									className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 dark:border-dark-border bg-gray-50 dark:bg-dark-bg px-3 py-2.5"
								>
									<div className="min-w-0">
										<div className="text-xs text-gray-500 dark:text-dark-text-secondary">{item.label}</div>
										<div className="text-sm font-semibold text-gray-900 dark:text-dark-text truncate">
											{item.value}
										</div>
									</div>
									<div className="flex shrink-0 items-center gap-1">
										{onEdit && (
											<button
												type="button"
												onClick={() => onEdit(item.id)}
												disabled={deletingId === item.id}
												className="flex h-8 w-8 items-center justify-center rounded-full text-gray-600 dark:text-dark-text-secondary hover:bg-gray-200 dark:hover:bg-dark-border disabled:opacity-50 transition"
												aria-label={`Edit reading from ${item.label}`}
												title="Edit reading"
											>
												<i className="fa-solid fa-pencil text-sm" aria-hidden="true" />
											</button>
										)}
										<button
											type="button"
											onClick={() => onDelete(item.id)}
											disabled={deletingId === item.id}
											className="flex h-8 w-8 items-center justify-center rounded-full text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900 dark:hover:bg-opacity-25 disabled:opacity-50 transition"
											aria-label={`Delete reading from ${item.label}`}
											title="Delete reading"
										>
											<i className="fa-solid fa-trash-can text-sm" aria-hidden="true" />
										</button>
									</div>
								</li>
							))}
						</ul>
					)}
				</div>
			</div>
		</div>
	);
}
